import useTranslation from 'next-translate/useTranslation';

import { Button } from '../buttons';

interface RetryButtonProps {
  onRetry?: () => void;
  isLoading?: boolean;
}
export default function RetryButton(props: RetryButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      style={{
        minWidth: 200,
      }}
      buttonType="secondary"
      isLoading={props.isLoading}
      onClick={props.onRetry}
    >
      {t('common:retry')}
    </Button>
  );
}
